import BarChartBase from "components/charts/BarChartBase";

export default function MonthlyWorkHoursGraph() {

const data = [
    { month: "May", hours: 0 },
    // { month: "Jun", hours: 176 },
    // { month: "Jul", hours: 172 },
    // { month: "Aug", hours: 180 },
    // { month: "Sep", hours: 168 },
    // { month: "Oct", hours: 152 },
];

return (
      <div className="text-sm font-semibold mb-3 space-y-4">
        <h4 className="title-text">Monthly Work Hours Trend</h4>
          <BarChartBase 
              data={data}
              xKey="month"
              yKey="hours"
          />
      </div>
  );
};
